import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

declare global {
  interface Window {
    OT: typeof import('@opentok/client');
  }
}

@Injectable({ providedIn: 'root' })
export class OpenTokLoaderService {
  private ot$ = new ReplaySubject<typeof window.OT>(1);
  private loaded = false;

  load(): Observable<typeof window.OT> {
    if (!this.loaded) {
      this.loaded = true;

      // Already present (reload / SSR hydration / cached)
      if (window.OT) {
        this.ot$.next(window.OT);
        this.ot$.complete();
        return this.ot$.asObservable();
      }

      const script = document.createElement('script');
      script.src = 'https://static.opentok.com/v2/js/opentok.min.js';
      script.async = true;

      script.onload = () => {
        this.ot$.next(window.OT);
        this.ot$.complete();
      };

      script.onerror = (err) => {
        this.loaded = false; // allow retry
        this.ot$.error(err);
      };

      document.body.appendChild(script);
    }

    return this.ot$.asObservable();
  }
}
